import { Link } from "react-router-dom";

/** A clear recovery point for mistyped, expired, or moved links. */
export function NotFoundPage() {
  return (
    <div className="not-found card text-center">
      <span className="not-found-code">404</span>
      <h1>That page could not be found</h1>
      <p className="text-muted">
        The link may be out of date, or the address may have been typed incorrectly.
      </p>
      <Link to="/" className="btn btn-primary">
        Go to home
      </Link>
    </div>
  );
}
